import $ from 'jquery';
import bootbox from 'bootbox';
import Api from 'apiRequests';

var requestForm = document.querySelector('#send-request form');

if (requestForm) {
    requestForm.addEventListener('submit', function(e) {
        e.preventDefault();
        grecaptcha.execute();
    });

    window.recaptchaCallback = function(token) {
        var formData = $(requestForm).serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});
        Api.sendPricesRequest(formData, requestForm.action).then(function(response) {
            requestForm.innerHTML = response.message;
        })
    };

    $('.send-request').on("click", function(e) {
        e.preventDefault();
        const dialog = bootbox.dialog({
            title: 'Оставить заявку',
            message: document.getElementById('send-request'),
            backdrop:true,
            onEscape: function() {
                $('body').append(document.getElementById('send-request'));
                $('.g-recaptcha').addClass('d-none');
                dialog.off('shown.bs.modal');
            },
            buttons: {}
        });

        dialog.on('shown.bs.modal', function(){
            $('.g-recaptcha').removeClass('d-none');
        });
    });
}
